var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgParaASuaCasa = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31837 8.74761C3.57336 9.95063 4.2774 11.5255 5.67036 11.7715L7.01689 12.0089V16.1621H8.01689V12.1852L10.0169 12.5378V20.162H8.26689C7.16275 20.162 6.26689 21.0579 6.26689 22.162V24.1621H17.7669V22.162C17.7669 21.0579 16.871 20.162 15.7669 20.162H14.0169V13.243L17.5564 13.867C18.9503 14.113 20.1515 12.8738 19.8615 11.4886L18.0443 2.79034C17.8772 1.99009 17.2391 1.37213 16.4333 1.23017L11.0476 0.280682C10.2424 0.138646 9.43156 0.500952 9.00064 1.19582L4.31837 8.74761ZM13.0169 20.1621V13.0667L11.0169 12.7141V20.1621H13.0169ZM18.8826 11.6939C19.0276 12.3864 18.4273 13.0058 17.7301 12.8827L5.84413 10.7872C5.14783 10.6643 4.79573 9.87667 5.16841 9.27489L9.85052 1.72337C10.0658 1.37616 10.4713 1.195 10.874 1.26604L16.2598 2.21555C16.6629 2.28657 16.9819 2.59551 17.0654 2.99531L18.8826 11.6939ZM7.26689 23.162V22.162C7.26689 21.6102 7.71504 21.1621 8.26689 21.1621H15.7669C16.3188 21.1621 16.7669 21.6102 16.7669 22.162V23.162H7.26689Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgParaASuaCasa;